import { Checkbox, Tooltip } from "antd";
import React from "react";
import "./CreateTicketDisplay.css";

const CreateTicket = ({
  showForMembers,
  showForFans,
  showOnWeb,
  checkChange,
}) => {
  const tooltipContent = (
    <div className="create-ticket-display-tooltip">
      <p>
        (Optional) If group uses the non-member (Fan) role in the app and/or has
        a Chant website you can choose to display tickets on the web.
      </p>
      <p>You can set separate non-member pricing for the web and app.</p>
      <p>
        Note that max quantity per person can not be controlled on the web --
        guests can purchase, then purchase again. Web tickets should not be used
        for tickets where a max quantity is important, or should be first
        offered to members.
      </p>
    </div>
  );

  return (
    <div className="create-ticket-display-container">
      <div className="create-ticket-display-card">
        <h3 className="create-ticket-display-title">Display</h3>

        <div className="create-ticket-display-options">
          {/* Show to members */}
          <div className="create-ticket-display-option">
            <Checkbox
              checked={showForMembers}
              onChange={checkChange}
              name="showForMembers"
              tabIndex="5"
            />
            <div className="create-ticket-display-option-content">
              <div className="create-ticket-display-option-header">
                <label className="create-ticket-display-option-label">
                  Show to members (in app)?
                </label>
                <Tooltip placement="topLeft" title={tooltipContent}>
                  <i className="fa fa-question-circle-o create-ticket-display-option-icon" />
                </Tooltip>
              </div>
            </div>
          </div>

          {/* Show to fans */}
          <div className="create-ticket-display-option">
            <Checkbox
              checked={showForFans}
              onChange={checkChange}
              name="showForFans"
              tabIndex="5"
            />
            <div className="create-ticket-display-option-content">
              <div className="create-ticket-display-option-header">
                <label className="create-ticket-display-option-label">
                  Show to fans (in app)?
                </label>
                <Tooltip placement="topLeft" title={tooltipContent}>
                  <i className="fa fa-question-circle-o create-ticket-display-option-icon" />
                </Tooltip>
              </div>
              <p className="create-ticket-display-option-description">
                If you allow fans (non-members) in app you can show the ticket
                and use non-member pricing. Note: If you want to manage ticket
                inventory separately for members and non-members, create a
                separate ticket.
              </p>
            </div>
          </div>

          {/* Publish to web */}
          <div className="create-ticket-display-option">
            <Checkbox
              checked={showOnWeb}
              onChange={checkChange}
              name="showOnWeb"
              tabIndex="5"
            />
            <div className="create-ticket-display-option-content">
              <div className="create-ticket-display-option-header">
                <label className="create-ticket-display-option-label">
                  Publish to web?
                </label>
                <Tooltip placement="topLeft" title={tooltipContent}>
                  <i className="fa fa-question-circle-o create-ticket-display-option-icon" />
                </Tooltip>
              </div>
              <p className="create-ticket-display-option-description">
                If checked a web URL will be generated. Web tickets are openly
                available to anyone who access the webpage. Limit per person is
                controlled per transaction but anyone can purchase again with no
                restrictions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateTicket;
